var filters = angular.module('bbl.filters', []);

filters.filter('moment', function() {
	return function(input, format) {
		return moment(input).format(format);
	};
});


/*****************
 ** WEBPACK FOOTER
 ** ./app/common/filters/index.js
 ** module id = 193
 ** module chunks = 0
 **/